import { Star, Quote } from 'lucide-react';
import { testimonials } from '../data/mock';

const Testimonials = () => {
  return (
    <section id="testimonials" className="testimonials-section">
      <div className="container">
        <div className="section-header">
          <h2 className="section-title">Ce Que Nos Clients Disent</h2>
          <p className="section-subtitle">
            La satisfaction de nos clients est notre plus grande fierté
          </p>
        </div>

        <div className="testimonials-grid">
          {testimonials.map((testimonial) => (
            <div key={testimonial.id} className="testimonial-card">
              <div className="testimonial-quote-icon">
                <Quote size={32} />
              </div>
              
              <div className="testimonial-rating">
                {[...Array(testimonial.rating)].map((_, index) => (
                  <Star key={`star-${testimonial.id}-${index}`} size={20} fill="#FFD700" color="#FFD700" />
                ))}
              </div>

              <p className="testimonial-text">"{testimonial.text}"</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
